$(document).ready(function () {
	loadDoneWebsite();
	swiperInit();
	setTimeout(() => {
		$(".wrap-product-slide").addClass("active");
	}, 200);
	setTimeout(() => {
		$(".productpage").addClass("active");
	}, 200);
	categoryActiveLoaded();
	setBackgroundElement();
	// header
	mappingMenu();
	menuMobile();
	// swiper
	// hheader
	if ($(".homepage").length >= 1 || $(window).width() < 575) {
		Header2();
	}
	//layout
	checkLayoutBanner();
	backToTop();
	//Checkscroll
	if ($(window).width() < 1280) {
		checkScorll();
	}
	headerMobile.clickHambuger();
	headerMobile.clickMobileMenu();
	headerMobile.clickMobileMenu2();
	FilterCategory();
	ClickFilterProduct();
	// ZoomImg();
	clickCart();
	checkDiaChi();
	InsertMobileAccount();
	CheckFilterCate();
	phantrang();
	checkLang();
	clickButtonTool();
	appendTitleClose();
	checkScrollHiddenCart();
	infiScrollProduct();
	appendNameAccount();
	checkActiveCart();
	cloneHome();
	clickScrollAccount();
});
/*==================== Click scroll account ====================*/
function clickScrollAccount() {
	console.log($(".user-sidelink").length);
	if (!$(window).width() > 575 && !$(".user-sidelink").length) {
		console.log("runggg");
		if (!$(".dashboardPage").length) {
		}
	}
	if ($(window).width() > 575 && !$(".user-sidelink").length) return;
	if ($(".dashboardPage").length) return;
	let offsetDiv = $(".col-lg-9").offset().top - 100;
	$("html, body").animate({
		scrollTop: offsetDiv,
	});
}
/*==================== Check active ====================*/
function checkActiveCart() {
	var url = window.location.href;
	console.log(url);
	$(".tool-menu-mobile a").each(function () {
		if (url == this.href) {
			$(this).closest("li").addClass("active");
		}
	});
}
/*====================  ====================*/
function appendNameAccount() {
	if ($(window).width() < 575 && $(".firstnav").length) {
		let text = $(".firstnav").text();
		let link = $(".firstnav").find("a").attr("href");
		$(".acount-mobile-text").find(".text").text(text);
		$(".acount-mobile-text").find("a").attr("href", link);
	}
}
/*==================== Infinite Scroll Product ====================*/
function infiScrollProduct() {
	$(".page-product-list .wrap-product-main .row").infiniteScroll({
		path: ".PagerOtherPageCells .ModulePager",
		append: ".col-md-4",
		status: ".pagination-loading",
		hideNav: ".pagination",
	});
	console.log("play loading");
}
/*==================== Mobile cart ====================*/
function checkScrollHiddenCart(params) {
	$(window).scroll(function (event) {
		let activeTrue = true;
		if (
			$(".shopping-cart-wrapper").hasClass("active") &&
			activeTrue == true
		) {
			activeTrue = false;
			$(".shopping-cart-wrapper").removeClass("active");
			setTimeout(() => {
				activeTrue = true;
			}, 3000);
		}
	});
}
/*==================== LoaddoneWebsite ====================*/
function loadDoneWebsite() {
	if ($(window).width() <= 1024) {
		$("header").addClass("loadDone");
	}
}
// Filter Category active loaded
function categoryActiveLoaded() {
	$("li.dropdown").each(function () {
		if ($(this).hasClass("active")) {
			$(this).children("ul").slideDown(0);
		}
	});
}
/*==================== Clone Home ====================*/
function cloneHome() {
	if ($(window).width() <= 1024) {
		$(".wrap-main-menu-mb .list-menu").each(function (index) {
			$(this).addClass("index" + index);
			if (index == 1) {
				$(this)
					.clone()
					.prependTo(".wrap-main-menu-mb")
					.addClass("lise-home-specify");
			}
		});
	}
}
/*==================== Append Title Close ====================*/
function appendTitleClose() {
	$(".list-content-link").prepend(
		'<div class="title-headline">Hỗ trợ khách hàng </div>'
	);
	$(".list-content-link .title-headline").click(function () {
		$(".list-content-link").toggleClass("active");
	});
}
/*==================== Click Button ====================*/
function clickButtonTool() {
	$(".button-expand").click(function () {
		$(this).toggleClass("active");
		$(".wrap-button-fixed").toggleClass("active");
	});
}
/*==================== Change Lang ====================*/
function checkLang() {
	$("#ctl00_mdl212_ctl00_subscribe1_txtEmail").attr(
		"placeholder",
		"Nhập email để nhận tin tức / mã khuyến mãi"
	);
}
/*==================== Cart  ====================*/
function InsertMobileAccount() {
	$(
		'<div class="button-account-profile"><p class="title-main">Thông tin tài khoản</p> <em class="material-icons"> add </em></div>'
	).insertBefore(".user-sidelink");
	if ($(window).width() < 1024) {
		$(".button-account-profile").click(function (e) {
			e.preventDefault();
			$(this).toggleClass("active");
			$(".user-sidelink").toggleClass("active");
		});
	}
}
function checkDiaChi() {
	$(".profile-container .address-info .type").each(function () {
		if (!$(this).text().trim()) {
			$(this).text("Phụ");
		} else {
			$(this).css("background-color", "#000000");
		}
	});
}
function clickCart() {
	if ($(window).width() >= 1024) {
		$(".wrap-cart-icon").click(function () {
			$(this)
				.closest("header")
				.find(".shopping-cart-wrapper")
				.toggleClass("active");
		});
	}

	$(window).click(function () {
		$(".shopping-cart-wrapper").removeClass("active");
	});

	$(".shopping-cart-wrapper").click(function (event) {
		event.stopPropagation();
	});
	$(".wrap-cart-icon").click(function (event) {
		event.stopPropagation();
	});
	$(".click-more-address").click(function () {
		$(".user-info").slideToggle();
	});
	if ($(window).width() < 1024) {
		let linkCart = $(".wrap-button-cart .button-cart").attr("href");
		$(".wrap-cart-icon").attr("href", linkCart);
	}
}
/*==================== Zoom IMG ====================*/
// function ZoomImg() {
// 	if ($(window).width() > 1024) {
// 		$(".wrap-slide-big .swiper-slide-active img").ezPlus({
// 			gallery: "gallery_01",
// 			responsive: true,
// 			scrollZoom: true,
// 			showLens: true,
// 			lenszoom: true,
// 			respond: [
// 				{
// 					range: "600-799",
// 					enabled: false,
// 					showLens: false,
// 				},
// 				{
// 					range: "800-1199",
// 					enabled: false,
// 					showLens: false,
// 				},
// 				{
// 					range: "100-599",
// 					enabled: false,
// 					showLens: false,
// 				},
// 			],
// 		});
// 	}
// }
/*==================== Buy Quantity Product ====================*/
/*==================== Filter Category ====================*/
function FilterCategory() {
	let main = $(".product-filter-cate .list-cate-main");
	let dropdown = $(".product-filter-cate .list-cate-main .dropdown")
		.children(".wrap-title")
		.find("em");
	dropdown.click(function () {
		$(this).parent().parent().toggleClass("active");
		$(this).parent().next().slideToggle();
	});
	// check active dropdown
}
function ClickFilterProduct(e) {
	$(".button-dmsp").click(function () {
		if ($(".wrap-filter-wrapper").is(".active")) {
			$(".button-blsp").trigger("click");
		}
		$(".side-navigation-wrapper").toggleClass("active");
		var text = $(this).text();
		$(this).text(
			text == "Danh mục sản phẩm"
				? "Đóng danh mục sản phẩm"
				: "Danh mục sản phẩm"
		);
	});
	$(".button-blsp").click(function () {
		if ($(".side-navigation-wrapper").is(".active")) {
			$(".button-dmsp").trigger("click");
		}
		$(".wrap-filter-wrapper").toggleClass("active");
		var text = $(this).text();
		$(this).text(
			text == "Bộ lọc sản phẩm"
				? "Đóng bộ lọc sản phẩm"
				: "Bộ lọc sản phẩm"
		);
	});
}
function CheckFilterCate() {
	if ($(".product-filter-checkbox").length == 0) {
		$(".button-blsp").remove();
	}
}
/*==================== Phan trang ====================*/
function phantrang() {
	$(".modulepager")
		.find(".pagination")
		.find("li>a.NextPage, li>a.LastPage, li>a.BackPage, li>a.FirstPage")
		.parent()
		.hide();
}
/*==================== Header Mobile ====================*/
let headerMobile = {
	clickHambuger: function () {
		$(".overlay").click(function () {
			$(".main-menu-mobile").removeClass("active");
			$(".overlay").removeClass("active");
		});
		$(".hambuger").click(function () {
			$(".main-menu-mobile").addClass("active");
			$(".overlay").addClass("active");
		});
		$(".main-menu-mobile .close").click(function () {
			// $(this).removeClass("active");
			$(".main-menu-mobile").removeClass("active");
			$(".overlay").removeClass("active");
			$(".hambuger").removeClass("active");
			$("header").removeClass("OpenMenu");
		});
	},
	clickMobileMenu2: function () {
		let close = $(".main-menu-mobile .close");
		let backPage = $(".main-menu-mobile .back-page");
		let $itemDropdown = $(".main-menu-mobile .item.dropdown>a");
		$itemDropdown.click(function () {
			$(this).next().addClass("active");
			close.css("display", "none");
			backPage.css("display", "block");
			return false;
		});
	},
	clickMobileMenu: function () {
		let close = $(".main-menu-mobile .close");
		let backPage = $(".main-menu-mobile .back-page");
		let $itemDropdown = $(".main-menu-mobile .list-item.dropdown").find(
			".icon"
		);
		let count = 0;
		$itemDropdown.click(function () {
			let attrDataCount = $(this).parent().next().attr("data-count");
			if (
				typeof attrDataCount !== typeof undefined &&
				attrDataCount !== false
			) {
			} else {
				count += 1;
				$(this).parent().next().attr("data-count", count);
			}
			$(this).parent().next().addClass("active");
			close.css("display", "none");
			backPage.css("display", "block");
			backPage.attr("close-count", count);
		});
		backPage.click(function () {
			// let countBack = Number($(this).attr("close-count"));
			if (!$(".item .list-menu-sub").hasClass("active")) {
				$("[data-count=" + count + "]").removeClass("active");
				$("[data-count=" + count + "]").removeAttr("data-count");
				if (count > 1) {
					count -= 1;
					backPage.attr("close-count", count);
				} else {
					count = 0;
					backPage.css("display", "none");
					close.css("display", "block");
				}
			} else {
				$(".list-menu-sub").removeClass("active");
				backPage.css("display", "none");
				close.css("display", "block");
			}
		});
	},
};
$(document).on("scroll", function () {
	if ($(window).width() < 575) {
		header.scrollActive();
	}
	if ($(window).width() >= 1280) {
		header.scrollChild();
	}
});
/*==================== ScrollDown  ====================*/
const checkScorll = () => {
	$(window).scroll(function (event) {
		if ($(window).scrollTop() > 500) {
			var checkScroll = $(this).scrollTop();
			$("header").addClass("scroll-menu");
		} else {
			$("header").removeClass("scroll-menu");
		}
	});
	$("header .view-more")
		.appendTo(".wrap-main-menu-mb")
		.addClass("view-more-fixed");
};
/*==================== Check height ====================*/
function checkLayoutBanner() {
	let height = $("header").outerHeight();
	if ($(".homepage").length && $(window).width() > 1280) {
		$("main").css("padding-top", height - 40);
	} else {
		$("main").css("padding-top", height + 10);
	}
}
function height(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height);
		}, 100);
	});
}

let header = {
	scrollActive: function () {
		if ($(window).width() > 1280 || $(window).width() < 575) {
			let height = $("header").height();
			if ($(window).scrollTop() > height) {
				$(".header-1").addClass("hide");
				$(".header-1").removeClass("active");
				$(".header-2").addClass("active");
				$(".header-2").removeClass("hide");
			} else {
				$(".header-1").addClass("active");
				$(".header-1").removeClass("hide");
				$(".header-2").addClass("hide");
				$(".header-2").removeClass("active");
			}
		}
	},
	scrollChild: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$(".header-1").addClass("scroll-menu-desktop");
		} else {
			$(".header-1").removeClass("scroll-menu-desktop");
		}
	},
};
/*==================== Header 2 ====================*/
const Header2 = () => {
	if ($(window).width() > 1280 || $(window).width() < 768) {
		$(".header-1")
			.clone()
			.addClass("header-2")
			.removeClass("header-1")
			.insertAfter("header");
		$(".header-2").addClass("hide");
		$(".header-1").addClass("active");
	}
};
function setBackgroundElement() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		var bgMobile = $(this).attr("setBackgroundMobile");
		var breakpoint = $(this).attr("breakpoint");
		if (typeof bgMobile != "undefined") {
			if ($(window).width() <= breakpoint) {
				$(this).css({
					"background-size": "cover",
					"background-position": "center center",
					"background-image": "url(" + bgMobile + ")",
				});
			} else {
				$(this).css({
					"background-size": "cover",
					"background-position": "center center",
					"background-image": "url(" + background + ")",
				});
			}
		} else {
			$(this).css({
				"background-size": "cover",
				"background-position": "center center",
				"background-image": "url(" + background + ")",
			});
		}
	});
	$("[setBackgroundRepeat]").each(function () {
		var background = $(this).attr("setBackgroundRepeat");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-repeat": "repeat",
		});
	});
}
/*==================== Hotline Fixed ====================*/
function backToTop() {
	$(".button-to-top").click(function () {
		$("html, body").animate(
			{
				scrollTop: 0,
			},
			300
		);
	});
}
function mappingMenu() {
	let mainMenuSearch = $("header .wrap-right .hambuger").mapping({
		mobileWrapper: "header .wrap-right",
		mobileMethod: "prependTo",
		desktopWrapper: "header .wrap-right",
		desktopMethod: "appendTo",
		breakpoint: 575,
	});

	let mainMenu = $("header .main-menu-sub .list-menu").mapping({
		mobileWrapper: ".main-menu-mobile .wrap-main-menu-mb",
		mobileMethod: "prependTo",
		desktopWrapper: "header .main-menu-sub",
		desktopMethod: "appendTo",
		breakpoint: 1280,
	});
	let mainMenuLeft = $("header .wrap-left-menu .list-menu").mapping({
		mobileWrapper: ".main-menu-mobile .wrap-main-menu-mb",
		mobileMethod: "appendTo",
		desktopWrapper: "header .wrap-left-menu",
		desktopMethod: "appendTo",
		breakpoint: 1280,
	});
	// let Account = $("header .wrap-account-main .account-wrapper").mapping({
	// 	mobileWrapper: "header .main-menu-mobile .wrap-main-menu-mb",
	// 	mobileMethod: "appendTo",
	// 	desktopWrapper: "header .wrap-account-main",
	// 	desktopMethod: "appendTo",
	// 	breakpoint: 1024,
	// });
	let ChangeLang = $("header .dropdown-lang").mapping({
		mobileWrapper: ".main-menu-mobile .wrap-main-menu-mb",
		mobileMethod: "appendTo",
		desktopWrapper: "header .wrap-account-main",
		desktopMethod: "insertAfter",
		breakpoint: 1024,
	});
	if ($(window).width() < 575) {
		$("header nav .main-menu .logo")
			.clone()
			.addClass("logo-2")
			.removeClass("logo")
			.prependTo("header nav .main-menu .wrap-right");
	}
}

function menuMobile() {
	let hamburger = $(".button-hambuger .burger-bt-inner");
	let menuMobile = $(".mobile-wrap");
	hamburger.on("click", function () {
		$(this).toggleClass("active");
		menuMobile.toggleClass("active");
	});
}

function swiperInit() {
	var bannerHome = new Swiper(".home-1-section .swiper-container", {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 3000,
		},
		speed: 800,
		pagination: {
			el: ".home-1-section .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".home-1-section .btn-next",
			prevEl: ".home-1-section .btn-prev",
		},
	});

	var Home3Banner = new Swiper(".home-3-section .swiper-container", {
		slidesPerView: 1,
		spaceBetween: 10,
		autoplay: {
			delay: 3000,
		},
		loop: true,
		speed: 1000,
		pagination: {
			el: ".home-3-section .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".home-3-section .btn-next",
			prevEl: ".home-3-section .btn-prev",
		},
	});
	var home4Bog = new Swiper(".home-4-blog .swiper-container", {
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 30,
		speed: 1000,
		loop: true,
		slidesPerColumnFill: "row",
		navigation: {
			nextEl: ".home-4-blog .btn-next",
			prevEl: ".home-4-blog .btn-prev",
		},
	});
	var HomeDoiTac = new Swiper(".home-5-section .swiper-container", {
		slidesPerView: 3,
		spaceBetween: 10,
		loop: true,
		autoplay: {
			delay: 1500,
			disableOnInteraction: false,
		},
		speed: 500,
		navigation: {
			nextEl: ".home-5-section .btn-next",
			prevEl: ".home-5-section .btn-prev",
		},
		breakpoints: {
			575: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 10,
			},
			1280: {
				slidesPerView: 8,
				spaceBetween: 30,
			},
		},
	});
	var HomeDoiTac = new Swiper(".page-blog-other .swiper-container", {
		slidesPerView: 1,
		spaceBetween: 10,
		navigation: {
			nextEl: ".page-blog-other .btn-next",
			prevEl: ".page-blog-other .btn-prev",
		},
		pagination: {
			el: ".page-blog-other .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			575: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});
	/*==================== Slide Product ====================*/
	$(".wrap-section-product .swiper-container").each(function (index) {
		$(this).addClass("slider-product-" + index);
		$(this)
			.closest(".wrap-section-product")
			.find(".btn-next")
			.addClass("btn-next-" + index);
		$(this)
			.closest(".wrap-section-product")
			.find(".btn-prev")
			.addClass("btn-prev-" + index);
		new Swiper(".slider-product-" + index, {
			slidesPerView: 2,
			slidesPerGroup: 2,
			speed: 800,
			spaceBetween: 15,
			loop: true,
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index,
			},
			breakpoints: {
				575: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 15,
				},
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 25,
				},

				1280: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 50,
				},
			},
		});
	});
	// var productDetailThumbs = new Swiper(
	// 	".page-product-detail .wrap-slide-thumb .swiper-container",
	// 	{
	// 		slidesPerView: 3,
	// 		spaceBetween: 12,
	// 		speed: 1000,
	// 		observer: true,
	// 		observeParents: true,

	// 		breakpoints: {
	// 			414: {
	// 				slidesPerView: 3,
	// 			},
	// 			768: {
	// 				slidesPerView: 3,
	// 			},
	// 		},
	// 	}
	// );
	// var productDetailTop = new Swiper(
	// 	".page-product-detail .wrap-slide-big .swiper-container",
	// 	{
	// 		slidesPerView: 1,
	// 		spaceBetween: 10,
	// 		observer: true,
	// 		observeParents: true,
	// 		speed: 1000,
	// 		slidesPerColumnFill: "row",
	// 		on: {
	// 			slideChangeTransitionEnd: function slideChangeTransitionEnd() {
	// 				ZoomImg();
	// 			},
	// 		},
	// 		thumbs: {
	// 			swiper: productDetailThumbs,
	// 		},
	// 		navigation: {
	// 			nextEl: ".page-product-detail .btn-next",
	// 			prevEl: ".page-product-detail .btn-prev",
	// 		},
	// 	}
	// );
}
